<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="模式名称" prop="modeName">
        <a-input v-model="form.modeName" placeholder="请输入" disabled :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="压降数值" prop="pressureDropValue">
        <a-input
          v-model="form.pressureDropValue"
          placeholder="请输入"
          :maxLength="4"
        />
      </a-form-model-item>

      <a-form-model-item label="目标压力值" prop="targetPressureValue">
        <a-input
          v-model="form.targetPressureValue"
          placeholder="请输入"
          oninput="value=value.replace(/[^\d]/g,'')"
          :maxLength="50"
        />
      </a-form-model-item>
      <!-- <a-form-model-item label="压降数值" prop="pressureDropValue">
        <a-input
          v-model="form.pressureDropValue"
          placeholder="请输入"
          oninput="value=value.replace(/[^\d]/g,'')"
          :maxLength="50"
        />
      </a-form-model-item> -->
      <a-form-model-item label="保压时间(分钟)" prop="maintainingPressureTime">
        <a-input
          v-model="form.maintainingPressureTime"
          placeholder="请输入"
          oninput="value=value.replace(/[^\d]/g,'')"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="稳压时间(分钟)" prop="stableVoltageTime">
        <a-input
          v-model="form.stableVoltageTime"
          placeholder="请输入"
          oninput="value=value.replace(/[^\d]/g,'')"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/pressure/parameter'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    const reg = /^0(\.\d)?|1$/
    const validateYa = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入压降数值'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的压降数值(0-1)'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        productName: undefined,
        productCode: undefined,
        optionalUnit: undefined,
        sort: 99,
        modelCaliberAddParams: [],
      },
      isShow: false,
      tags: [],
      tagslist: [],
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      inputVisible: false,
      inputVisibles: false,
      rules: {
        pressureDropValue: [{ required: true, message: '请输入压降数值', trigger: 'blur' }, { validator: validateYa, trigger: ['blur', 'change'] }],
        targetPressureValue: [{ required: true, message: '请输入目标压力值', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        maintainingPressureTime: [{ required: true, message: '请输入保压时间', trigger: 'blur' }],
        stableVoltageTime: [{ required: true, message: '请输入稳压时间(分钟)', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        productName: undefined,
        productCode: undefined,
        optionalUnit: undefined,
        sort: 99,
        modelCaliberAddParams: [],
      }
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      console.log(row, '顶顶顶顶')
      this.form = JSON.parse(JSON.stringify(row))
      this.formTitle = '修改参数'
      this.open = true
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
</style>
